import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Image from '~/components/base/Image';
import BaseLink from '~/components/base/BaseLink';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    white-space: nowrap;
`;

const LogoContainer = styled.div`
    position: relative;
    width: 200px;
    height: 45px;

    @media (min-width: ${({ theme }) => theme.breakpoint.largePhone}) {
        width: 258px;
        height: 58px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoint.largeTablet}) {
        width: 120px;
        height: 70px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
        width: 127px;
        height: 80px;
    }

    @media (min-width: 1400px) {
        height: 86px;
        width: 134px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoint.headerBreak}) {
        width: 140px;
        height: 90px;
        margin-right: 145px;
    }
`;

const Logo = styled(Image)`
    position: absolute !important;
    display: none !important;
    bottom: 0;

    @media (min-width: ${({ theme }) => theme.breakpoint.largeTablet}) {
        display: block !important;
    }
`;

const MobileLogo = styled(Image)`
    position: absolute !important;
    top: 50%;
    transform: translate(0, -50%);

    @media (min-width: ${({ theme }) => theme.breakpoint.largeTablet}) {
        display: none !important;
    }
`;

const StyledLink = styled(BaseLink)`
    display: block;
    width: 100%;
    height: 100%;
`;

const LeftNav = ({ logo, mobileLogo }) => (
    <Wrapper>
        <LogoContainer>
            <StyledLink to="/">
                <Logo {...logo} />
                <MobileLogo {...mobileLogo} />
            </StyledLink>
        </LogoContainer>
    </Wrapper>
);

LeftNav.propTypes = {
    logo: PropTypes.object.isRequired,
    mobileLogo: PropTypes.object.isRequired
};

export default LeftNav;
